<main-content-holder>
  <h2 *ngIf="!confirmRole && !inviteRequestMode && studentSignUp" class="center-align"
      i18n="Sign Up|Sign Up Student title@@sign-up-student-title">Create New Student Account</h2>
  <h2 *ngIf="!confirmRole && !inviteRequestMode && !studentSignUp" class="center-align"
      i18n="Sign Up|Sign Up Teacher title@@sign-up-teacher-title">Create New Teacher Account</h2>
  <h2 *ngIf="confirmRole && !invitationExpired" class="center-align"
      i18n="Sign Up|Sign Up Finish sign-up title@@sign-up-finish-sign-up-title">Complete Account Setup</h2>
  <h2 *ngIf="inviteRequestMode" class="center-align"
      i18n="Sign Up|Sign Up request invitation title@@sign-up-request-invitation-title">Request New Invitation</h2>

  <div *ngIf="inviteRequestMode" class="full-width request-invitation-block">
    <form [formGroup]="signUpForm" class="center-align">
      <form-input [control]="emailField"
                  label="Email"
                  i18n-label="Sign Up|Email input label@@sign-up-email-label"
                  placeholder="Your email..."
                  i18n-placeholder="Sign Up|Email input placeholder@@sign-up-email-placeholder"
                  autocomplete="email"
                  type="email"
                  suffixButton="person_search"
                  [suffixAction]="searchUserByEmail"
                  [minLength]="5" [maxLength]="128"
                  (focusLost)="searchUserByEmail()"
                  (keyUpEnter)="searchUserByEmail()"></form-input>
    </form>

    <div class="">
      <mat-spinner *ngIf="inProgress" color="primary" diameter="30" class="center"></mat-spinner>
      <div *ngIf="userExistenceChecked && !inProgress && !userExists" class="color-green center-align"
           i18n="Sign Up|Sign Up invitation user not found notification@@sign-up-invitation-user-not-found-notification">
        A user profile was not found, and therefore invitation cannot be sent. You can sign up for a new account.
      </div>
      <div *ngIf="userExists" class="center-align">
        <app-button *ngIf="userStatus == 'FORCE_CHANGE_PASSWORD'"
                    label="Request New Invitation" #requestInvitationBtn
                    i18n-label="Sign Up|Request New Invitation button label@@sign-up-request-new-invitation-btn-label"
                    class="center request-invitation-btn"
                    (clicked)="requestInvitation(requestInvitationBtn);"></app-button>

        <div *ngIf="invitationRequestDetails" class="invitation-confirmation">{{invitationRequestDetails}}</div>

        <ng-container *ngIf="userStatus == 'UNCONFIRMED'"
                      i18n="Sign Up|Sign Up invitation user incorrect state (unconfirmed) notification@@sign-up-invitation-user-incorrect-state-unconfirmed-notification">
          A user profile was found, but the sign-up process was not finished (email not confirmed). A new invitation cannot be requested because you signed up without an invitation. Just sign in with your credentials to complete your profile setup or reset your password if you forgot it.
        </ng-container>
        <ng-container *ngIf="userStatus == 'RESET_REQUIRED'"
                      i18n="Sign Up|Sign Up invitation user incorrect state (reset_required) notification@@sign-up-invitation-user-incorrect-state-reset_required-notification">
          A user profile was found, and it is in the middle of the password reset process. Finish your password reset process to access your account.
        </ng-container>

        <ng-container *ngIf="userStatus != 'FORCE_CHANGE_PASSWORD' && userStatus != 'UNCONFIRMED' && userStatus != 'RESET_REQUIRED'"
                      i18n="Sign Up|Sign Up invitation user incorrect state notification@@sign-up-invitation-user-incorrect-state-notification">
          A user profile was found, but the invitation was already accepted, or the profile was activated in another way. Just sign in with your credentials or reset your password if you forgot it.
        </ng-container>
      </div>
    </div>
  </div>

  <div *ngIf="confirmUsername && invitationExpired" class="full-width expired-invitation-block">
    <app-no-content title="Invitation has already expired"
                    i18n-title="Sign Up|Sign Up Finish sign-up invitation expired title@@sign-up-finish-sign-up-invitation-expired-title"
                    [details]="invitationRequestDetails"
                    [compact]="true">
      <mat-spinner *ngIf="inProgress" color="primary" class="center" [diameter]="30"></mat-spinner>

      <app-button label="Request New Invitation" #requestInvitationBtn
                  i18n-label="Sign Up|Request New Invitation button label@@sign-up-request-new-invitation-btn-label"
                  class="center request-invitation-btn"
                  (clicked)="requestInvitation(requestInvitationBtn);"></app-button>
    </app-no-content>
  </div>

  <div *ngIf="confirmUsername && !userExistenceChecked" class="user-details-loading-progress">
    <mat-spinner color="primary" diameter="30" class="center"></mat-spinner>
  </div>

  <div *ngIf="!invitationExpired && !inviteRequestMode && (!confirmUsername || userExistenceChecked)"
       fxLayout="row" fxLayout.lt-md="column" class="full-width">
    <form [fxFlex]="confirmUsername || !allowSocialSignIn ? '98%' : '48%'"
          [formGroup]="signUpForm" class="center-align">
      <form-input [control]="emailField"
                  label="Email"
                  i18n-label="Sign Up|Email input label@@sign-up-email-label"
                  placeholder="Your email..."
                  i18n-placeholder="Sign Up|Email input placeholder@@sign-up-email-placeholder"
                  autocomplete="email"
                  type="email"
                  [minLength]="5" [maxLength]="128"
                  suffixIcon="perm_identity"
                  suffixTooltip="Sign In with your QuizWin account.&#13;It provides you with access to a group of supported competitions."
                  i18n-suffixTooltip="Sign In|Email input account help tooltip@@sign-in-email-account-help-tooltip"
                  (focusLost)="verifyUserExists()"></form-input>

      <div *ngIf="userExists" class="mat-small color-warn">
        <span i18n="Sign Up|User already exists help tooltip@@sign-up-user-exists-help-tooltip">
          Profile with this email already exists. Probably you have used it to register for other competitions that work with
          QuizWin accounts, or haven't completed account setup after invitation. You can try:</span>
        <ul class="left-align">
          <li i18n="Sign Up|User already exists help option 1@@sign-up-user-exists-help-option-1">
            sign in with your QuizWin account;
          </li>
          <li i18n="Sign Up|User already exists help option 2@@sign-up-user-exists-help-option-2">
            reset your password if you have lost access;
          </li>
          <li i18n="Sign Up|User already exists help option 3@@sign-up-user-exists-help-option-3">
            find invitation email in your inbox and finish registration;
          </li>
          <li>
            <ng-container i18n="Sign Up|User already exists help option 4@@sign-up-user-exists-help-option-4">
              contact our support team at email
            </ng-container>
            <app-link [href]="supportEmail"
                      class="link"
                      [label]="supportEmailLabel"
                      [external]="true"></app-link>
            ;
          </li>
        </ul>
      </div>

      <form-input *ngIf="phoneRequired"
                  [control]="phoneField"
                  type="tel"
                  label="Phone"
                  i18n-label="Sign Up|Phone input label@@sign-up-phone-label"
                  placeholder="Your phone (format like +380000000000)..."
                  i18n-placeholder="Sign Up|Phone input placeholder@@sign-up-phone-placeholder"
                  autocomplete="tel"
                  [minLength]="7" [maxLength]="15"></form-input>

      <form-input [control]="firstNameField"
                  label="First Name"
                  i18n-label="Sign Up|First Name input label@@sign-up-first-name-label"
                  placeholder="Your first name..."
                  i18n-placeholder="Sign Up|First Name input placeholder@@sign-up-first-name-placeholder"
                  autocomplete="given-name"
                  [minLength]="2" [maxLength]="128"></form-input>
      <form-input [control]="lastNameField"
                  label="Last Name"
                  i18n-label="Sign Up|Last Name input label@@sign-up-last-name-label"
                  placeholder="Your last name..."
                  i18n-placeholder="Sign Up|Last Name input placeholder@@sign-up-last-name-placeholder"
                  autocomplete="family-name"
                  [minLength]="2" [maxLength]="128"></form-input>
      <form-input *ngIf="confirmUsername && confirmRole"
                  [control]="roleField"
                  label="Role"
                  i18n-label="Sign Up|Sign Up role input label@@sign-up-role-input-label"
                  [options]="roles"
                  [compareWith]="compareRoles"
                  [displayWith]="displayRole"></form-input>
      <form-input [control]="passwordField"
                  label="Password"
                  i18n-label="Sign Up|Password input label@@sign-up-password-label"
                  type="password"
                  suffixButton="visibility"
                  suffixButtonAlt="visibility_off"></form-input>

      <div class="progress-block">
        <app-button *ngIf="!inProgress"
                    label="Sign Up"
                    i18n-label="Sign Up|Sign Up button label@@sign-up-btn-label"
                    class="center sign-up-btn"
                    width="205px"
                    [disabled]="shouldDisableSubmit()"
                    (clicked)="signUp()"></app-button>
        <mat-spinner *ngIf="inProgress" color="primary" class="center" [diameter]="30"></mat-spinner>
      </div>
    </form>

    <div *ngIf="!confirmUsername && allowSocialSignIn" fxHide.lt-md="true" class="or-divider">
      <mat-divider [vertical]="true" class="divider"></mat-divider>
      <span class="or text-disabled-color"
            i18n="Sign Up|Sign Up section divider (vertical)@@sign-up-section-divider-v-or">or</span>
      <mat-divider [vertical]="true" class="divider"></mat-divider>
    </div>

    <div *ngIf="!confirmUsername && allowSocialSignIn" fxHide.gt-sm="true" class="or-divider horizontal">
      <mat-divider class="fill-space"></mat-divider>
      <span class="or text-disabled-color"
            i18n="Sign Up|Sign Up section divider (horizontal)@@sign-up-section-divider-h-or">or</span>
      <mat-divider class="fill-space"></mat-divider>
    </div>

    <div *ngIf="!confirmUsername && allowSocialSignIn" fxFlex="48%" [ngClass.lt-md]="{'center': true}">
      <social-sign-in [disabled]="inProgress"
                      (progress)="inProgress = $event"></social-sign-in>
    </div>
  </div>

  <div class="agreement-block center">
    <div i18n="Sign Up|Sign Up agreement title@@sign-up-agreement-title">By creating a QuizWin account, you agree to
    </div>
    <div>
      <app-link [href]="termsUrl"
                [external]="true"
                label="Terms of Use"
                i18n-label="Sign Up|Terms of Use URL label@@sign-up-terms-label"></app-link>
      <span class="agreement-links-divider"
            i18n="Sign Up|Sign Up agreement links concat@@sign-up-agreement-links-concat">and</span>
      <app-link [href]="privacyUrl"
                [external]="true"
                label="Privacy Policy"
                i18n-label="Sign Up|Privacy Policy URL label@@sign-up-privacy-label"></app-link>
    </div>
  </div>

  <div class="footer center-align">
    <ng-container i18n="Sign Up|Existing account prompt@@sign-up-existing-account-prompt">Already have an account?
    </ng-container>
    <app-link [routerLink]="signInUrl"
              class="sign-in-link"
              label="Sign In"
              i18n-label="Sign Up|Sign In URL label@@sign-up-sign-in-url-label"></app-link>
  </div>
  <div [class.language-switch]="!mobileView" [class.language-switch-mobile]="mobileView">
    <language-switch theme="dark"></language-switch>
  </div>
</main-content-holder>
